// MOBILE MENU - v5.2 - June 2024 - Vanilla !
document.addEventListener('DOMContentLoaded', (function() {
	'use strict';

	function initializeMobileMenu() {


		const DEV = 0;


		// VARIABLES -------------------------------------
		const mobileMenuContainer	= document.querySelector('#nav_mobile_container');
		const hamburger			 	= document.querySelector('#hamburger_container');
		const navMobile 			= document.querySelector('#nav_mobile');
		const pageOverlay			= document.querySelector('.page_overlay');
		const barTopL1 				= document.querySelector('.bar_top.l1')
		const barTopL2 				= document.querySelector('.bar_top.l2');
		const barTopL3 				= document.querySelector('.bar_top.l3')
		const BRK_T 				= 1226
		const animationSpeed		= 290  
		let vpw 					= window.innerWidth;
		let vph 					= window.innerHeight;
		let lvl3_ON 				= false  // Level 3 ON/OFF
		let level2ul, level3ul;



		if(!navMobile || !hamburger) return;



		// ON RESIZE -------------------------------------
		window.addEventListener('resize', function() {
			vpw = window.innerWidth;
			vph = window.innerHeight;

			// ADJUST LEVEL_2  UL HEIGHT FOR OVERFLOW SCROLL
			let headerHeight = document.querySelector('#header').offsetHeight;

			navMobile.querySelectorAll('ul > li > ul').forEach(ul => {
				ul.style.height = `${vph - headerHeight}px`;
			});

			// MAKE MENU DISAPPEAR
			if (vpw > BRK_T) {
				// outOfLevel1()
				overlayOFF()
				mobileMenuContainer.classList.remove('opened');
				hamburger.classList.remove('is-active','back-arrow','l3-active');
				lvl3_ON = false
			};
	    });




		// OVERLAY FUNCTIONS ------------------
		function overlayON() {
			DEV && log('overlayON')
			pageOverlay.classList.add('active')
			pageOverlay.classList.remove('remove-active')
			fix_body_to_actual_y_position()

			// TRIGGER RESIZE
			setTimeout(function(){ 
				window.dispatchEvent(new Event("resize"));
			});
		};

		function overlayOFF() {
			DEV && log('overlayOFF')
			if (pageOverlay.classList.contains('active')) {
				pageOverlay.classList.add('remove-active');
				pageOverlay.classList.remove('active');
				unfix_body()
			}
		};
		if(pageOverlay) { pageOverlay.addEventListener('click', overlay_action); }
		function overlay_action() {
			outOfLevel1()
			if (level2ul !== undefined) {
				outOfLevel2()
			}
		}






		// HAMBURGER CLICK ACTION
		hamburger.addEventListener('click', hamburger_action);
		function hamburger_action() {
			if (!hamburger.classList.contains('is-active')) {

				hamburger.classList.add('is-active') 
				mobileMenuContainer.classList.add('opened')
				overlayON()

			} else {
				if (!hamburger.classList.contains('back-arrow')) {
					outOfLevel1()
				} else if (!hamburger.classList.contains('l3-active')) {
					outOfLevel2()
				} else {
					outOfLevel2()
				}
			}
		}





		// OUT OF LEVEL 1
		if(barTopL1) { barTopL1.addEventListener('click', outOfLevel1); }
		function outOfLevel1() {
			DEV && log('outOfLevel1')
			hamburger.classList.remove('is-active','back-arrow');
			mobileMenuContainer.classList.remove('opened')
			overlayOFF()
		};







		// TO LEVEL 2 ------------------------------
		navMobile.querySelectorAll("ul>.menu-item-has-children>a").forEach(function(el) {
			el.addEventListener('click', function(e) {

				hamburger.classList.add('back-arrow')

				e.preventDefault()

				level2ul = el.nextElementSibling;

				const nameOfParent = el.textContent;
				DEV && log('nameOfParent', nameOfParent)
				
				barTopL2.classList.add('opened');
		        barTopL2.setAttribute("data-slug", slugify(nameOfParent));
		        barTopL2.querySelector("p").textContent = nameOfParent;

				level2ul.classList.add('opened')
			});
		});

			// OUT OF LEVEL 2 
			if(barTopL2) { barTopL2.addEventListener('click', outOfLevel2); }
			function outOfLevel2() {
				DEV && log('outOfLevel2')
				hamburger.classList.remove('back-arrow');
				level2ul.classList.remove('opened');
				barTopL2.classList.remove('opened');
			}





		// TO LEVEL 3 ------------------------------
		navMobile.querySelectorAll(".menu-item-has-children .menu-item-has-children>a").forEach(el => {
	        el.addEventListener('click', function(e) {

				hamburger.classList.add('l3-active')

				e.preventDefault()

				let nameOfParent = el.textContent;

				barTopL3.classList.add('opened')
				barTopL3.querySelector("p").textContent = nameOfParent;

				level3ul = el.nextElementSibling;
				level3ul.classList.add('active')
				level3ul.querySelectorAll("li > a").forEach(a => {
		            a.animate([{ opacity: 0 }, { opacity: 1 }], {
		                duration: 350,
		                fill: 'forwards'
		            });
		        });
				lvl3_ON = true
			});
		});

			// OUT OF LEVEL 3
			if(barTopL3) { barTopL3.addEventListener('click', outOfLevel3);}
			function outOfLevel3() {
				DEV && log('outOfLevel3')

				hamburger.classList.remove('l3-active') 
				level3ul.classList.remove('active');
				level3ul.animate({ scrollTop: 0 }, animationSpeed)
				barTopL3.classList.remove('opened');
				navMobile.scrollTo({ top: 0, behavior: 'smooth' });
				navMobile.querySelectorAll('ul>li>ul>li>ul>li>a').forEach(function(a){
				    a.animate([{ opacity: 1 }, { opacity: 0.1 }], {
				        duration: 200,
				        fill: 'forwards'
				    });
				});
				lvl3_ON = false
			}




		// ON KEYPRESS ESCAPE
		document.addEventListener('keyup', function(e) {
			if(e.keyCode === 27) {
				if(hamburger.classList.contains('l3-active') ) {
					outOfLevel3()
				} else if(hamburger.classList.contains('back-arrow') ) {
					outOfLevel2()
				} else {
					outOfLevel1()
				}
			}
		})

	}

	initializeMobileMenu();

})); // end DOMContentLoaded
